import script from "./Online-Banking-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Online-Banking-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Online-Banking-Questionnaire-Main.vue?vue&type=style&index=0&id=07cde7f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07cde7f4"]])

export default __exports__